import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';
import ButtonsGroup from 'app/components/Button/ButtonsGroup.styled';
import B from 'app/components/Button/Button.styled';
import { startDirection } from 'app/styles/selectors/markup';
import { HEADER_HEIGHT } from 'app/features/header/constants';
import RGBA from 'app/styles/rgbToRgbaConverter';

const { widthSmall } = breakpoints;
const S = {};

S.BlackBackground = styled.div`
  position: absolute;
  width: 100%;
  height: ${HEADER_HEIGHT};

  @media (${widthSmall}) {
    background-color: ${RGBA('--colors-black', 0.9)};
  }
`;

S.Header = styled.header`
  label: Header;

  position: absolute;
  ${startDirection}: 50%;
  transform: ${({
    theme: {
      markup: { dir },
    },
  }) => (dir === 'ltr' ? 'translateX(-50%)' : 'translateX(50%)')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: var(--z-index-header);
  padding: 0 1.25rem;
  height: ${HEADER_HEIGHT};

  @media (${widthSmall}) {
    padding: 0 2.5rem;
    max-width: 77.5rem;
  }
`;

S.Header.ButtonHolder = styled(ButtonsGroup)`
  label: ButtonHolder;

  flex: 0 0 auto;

  ${({ isAuthenticated }) =>
    !isAuthenticated &&
    css`
      ${B.Button}:first-of-type {
        display: none;
      }

      ${B.Button}:last-of-type {
        display: inline-flex;
      }
    `}

  @media (${widthSmall}) {
    ${B.Button}:first-of-type {
      display: inline-flex;
    }
  }
`;

export default S;
